<template>
  <div class="btns__scores right-btn">
    <div v-if="props.value" class="score body-m-semibold" :class="colorClass">
      <div :itemprop="props.itemprop ? 'ratingValue' : undefined">
        {{ (props.value / 20).toFixed(1) }}
      </div>
    </div>
    <component
      :is="reviewComponent"
      :to="hrefReviewComponent"
      :event="''"
      class="reviews body-m-regular color-link reviews-scope"
      @click.prevent.stop="emit('addReview')"
    >
      <span v-if="reviewCount"> {{ reviewCount }} </span>
      {{ endWord(reviewCount || 0) }}
    </component>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(['addReview']);
const props = defineProps({
  value: {
    type: Number,
  },
  reviewCount: {
    type: Number,
  },
  itemprop: Boolean,
  reviewComponent: {
    type: String,
    default: 'div',
  },
  hrefReviewComponent: {
    type: String,
    default: '/',
  },
});

const endWord = (val: number): string => {
  return numWord(val, ['Оставить отзыв', 'отзыв', 'отзыва', 'отзывов']);
};

const colorClass = computed(() => {
  const rating = props?.value ? (props.value / 20).toFixed(1) : 0;
  if (rating >= 4.4 && rating < 4.9) {
    return 'green-lite';
  } else if (rating >= 3.9 && rating < 4.4) {
    return 'yellow';
  } else if (rating >= 2.9 && rating < 3.9) {
    return 'orange';
  } else if (rating < 2.9) {
    return 'red';
  }
  return 'green';
});
</script>
<style lang="scss" scoped>
.btns__scores {
  white-space: nowrap;

  .score {
    padding: 0 3px;
    border-radius: 2px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: $white;
    margin-right: 8px;
    @include xl-block {
      margin-right: 10px;
    }
  }

  .green {
    background: #24c352;
  }

  .green-lite {
    background: #87c324;
  }

  .yellow {
    background: #c1c62e;
  }

  .orange {
    background: #f9b024;
  }

  .red {
    background: #ff8126;
  }

  .reviews-scope {
    cursor: pointer;
    display: inline-block;
    margin-right: 24px;
    @include lg-block {
      margin-right: 32px;
    }
    @include xl-block {
      margin-right: 32px;
    }
  }
}
</style>
